//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const BanHtmlLikeDataInTextInputs: FeatureFlag = {"Id":"BanHtmlLikeDataInTextInputs","Label":"[10.13]Ban text that looks like HTML in text input","Impact":"Prevent users from submitting text that looks like HTML in text inputs and text areas. This means users that need or want to submit a form with something containing like <whatever> for example, they would be blocked from doing this.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
